module.exports = __webpack_public_path__ + "media/images/mid_gm_office-83c74c49.jpeg";